import pexels1 from "../../assets/pexels1.webp";
import pexels2 from "../../assets/pexels2.webp";
import shutterstock2 from "../../assets/shutterstock2.webp";
import shutterstock3 from "../../assets/shutterstock3.webp";

export const cards = [
  {
    image: pexels2,
    header: "Diversity & Inclusion",
    description:
      "We believe that different experiences, backgrounds and perspectives make us a stronger company.",
    button: "More Inclusion",
  },
  {
    image: pexels1,
    header: "Benefits",
    description:
      "Our unique work schedule and location flexibility lets you work when and where you want.",
    button: "View Benefits",
  },
  {
    image: shutterstock3,
    header: "Open Positions",
    description:
      "Whether you're a seasoned developer or gearing up to submit your first app, everyone can use a second review and prevent a rejection.",
    button: "See Positions",
  },
  {
    image: shutterstock2,
    header: "Hiring Process",
    description:
      "Whether you're a seasoned developer or gearing up to submit your first app, everyone can use a second review and prevent a rejection.",
    button: "Learn More",
  },
];
